import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../../../components/partials/PageTitle";
import Select from "../../../../components/form/select/Select";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  getSingleCover,
  resetUpdateCover,
  updateCover,
} from "../../../../redux/slice/cover/coverSlice";
import { useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";

const policies = [
  { name: "General Cover", id: "1" },
  { name: "Savings Policy", id: "2" },
  // { name: "Credit Life", id: "3" },
];
const SingleCover = () => {
  const [editing, setEditing] = useState(false);
  const [hasEditCover, setHasEditCover] = useState(null);
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { single_cover, updateSuccess } = useSelector((state) => state.cover);
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const breadcrumb = {
    from: {
      title: "Cover",
      link: "/admin/settings/cover",
    },
    current: {
      title: "Policy Cover View",
      link: null,
    },
  };

  const onSubmit = (values) => {
    console.log(values);
    let payload = { ...values, id: single_cover.id };
    dispatch(updateCover(payload));
  };

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleSubmit,
    setFieldValue,
    handleChange,
    // setFieldError,
    // resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      policy_category: single_cover?.PolicyCategory,
      cover_name: single_cover?.name,
      default_rate: single_cover?.default_rate,
      minimum_rate: single_cover?.minimum_rate,
      maximum_rate: single_cover?.maximum_rate,
    },
    onSubmit,
    validate: (values) => {
      const errors = {};
      if (
        single_cover?.is_savings === "1" &&
        values.policy_category === "2" &&
        !values.default_rate
      ) {
        errors.default_rate = "Default rate is required.";
      }
      if (
        single_cover?.is_savings === "1" &&
        values.policy_category === "2" &&
        !values.minimum_rate
      ) {
        errors.minimum_rate = "Minimum rate is required.";
      }
      if (
        single_cover?.is_savings === "1" &&
        values.policy_category === "2" &&
        !values.maximum_rate
      ) {
        errors.maximum_rate = "Maximum rate is required.";
      }
      if (values.policy_category === "2") {
        if (
          parseFloat(values?.default_rate) < parseFloat(values?.minimum_rate)
        ) {
          errors.minMax = "Default rate cannot be less than minimum rate";
        }
        if (
          parseFloat(values?.default_rate) > parseFloat(values?.maximum_rate)
        ) {
          errors.minMax = "Default rate cannot be greater than maximum rate";
        }
        if (
          parseFloat(values?.maximum_rate) < parseFloat(values?.minimum_rate)
        ) {
          errors.minMax = "Minimum rate cannot be greater than maximum rate";
        }
      }
      return errors;
    },
    validationSchema: () =>
      yup.object().shape({
        policy_category: yup.number().required("Policy Category is required"),
        cover_name: yup.string().required("Cover Name is required"),
      }),
  });

  const policyData = policies?.map((policy) => {
    return {
      label: policy.name,
      value: policy.id,
    };
  });

  const resetFormValues = () => {
    values.policy_category = single_cover?.PolicyCategory;
    values.cover_name = single_cover?.name;
    values.default_rate = single_cover?.default_rate;
    values.minimum_rate = single_cover?.minimum_rate;
    values.maximum_rate = single_cover?.maximum_rate;
  };

  useEffect(() => {
    dispatch(getSingleCover(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (updateSuccess) {
      setEditing(false);
      dispatch(getSingleCover(id));
      dispatch(resetUpdateCover());
    }
  }, [dispatch, id, updateSuccess]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "cover module"
      ) ||
      !user_permissions?.some((permission) => permission.name === "view cover")
    ) {
      navigate("/admin/dashboard");
    }

    setHasEditCover(
      user_permissions?.some((permission) => permission.name === "edit cover")
    );
  }, [navigate, user_permissions]);

  if (!single_cover) {
    return (
      <div className='mt-2'>
        <BeatLoader
          height='80'
          width='80'
          radius='9'
          color='#2e3192'
          ariaLabel='three-dots-loading'
          wrapperStyle={{}}
          wrapperClassName=''
          visible={true}
        />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='View Policy Cover' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <form onSubmit={handleSubmit}>
              <div className='row mb-3 mt-4'>
                <div className='col-md-3 col-lg-2 text-end sm-text-end'>
                  <label htmlFor='account_type' className={`form-label mt-1`}>
                    Policy Category <span className='text-danger'>*</span>
                  </label>
                </div>

                <div className='col-md-7 col-lg-6'>
                  {editing ? (
                    <div>
                      <Select
                        onBlur={() => {
                          handleBlur({ target: { name: "policy_category" } });
                        }}
                        name='policy_category'
                        // disabled={true}
                        data={policyData}
                        value={values?.policy_category}
                        onChange={(selectedOption) =>
                          setFieldValue(
                            "policy_category",
                            selectedOption?.value
                          )
                        }
                      />
                      {errors?.policy_category && touched?.policy_category && (
                        <p className='mb-0 text-danger'>
                          {errors?.policy_category + "*"}
                        </p>
                      )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {values?.policy_category === "1" && "General Policy"}
                      {values?.policy_category === "2" && "Savings Policy"}
                      {values?.policy_category === "3" && "Credit Life"}
                    </p>
                  )}
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-3 col-lg-2 text-right sm-text-end'>
                  <label htmlFor='name' className='col-form-label'>
                    Policy Cover Name
                    <span className='text-danger'> *</span>
                  </label>
                </div>
                <div className='col-md-7 col-lg-6'>
                  {editing ? (
                    <div>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        id='cover_name'
                        value={values?.cover_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors?.cover_name && touched?.cover_name && (
                        <p className='mb-0 text-danger'>
                          {errors?.cover_name + "*"}
                        </p>
                      )}
                    </div>
                  ) : (
                    <p className='form-control border-0 shadow'>
                      {values.cover_name}
                    </p>
                  )}
                </div>
              </div>
              {values.policy_category === "2" && (
                <div>
                  <div className='row mb-2 col-lg-11 mx-auto'>
                    <div className='col-md-4 mb-3'>
                      <label htmlFor='default_rate'>
                        Default rate <span className='text-danger'>*</span>
                      </label>
                      {editing ? (
                        <div>
                          <input
                            type='text'
                            className={`form-control ${
                              errors?.default_rate &&
                              touched?.default_rate &&
                              "is-invalid"
                            }`}
                            name='default_rate'
                            id='default_rate'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='0.00'
                            value={values?.default_rate}
                          />
                          {errors?.default_rate && touched?.default_rate && (
                            <span className='text-danger'>
                              {errors?.default_rate}
                            </span>
                          )}
                        </div>
                      ) : (
                        <p className='form-control border-0 shadow'>
                          {values.default_rate}
                        </p>
                      )}
                    </div>
                    <div className='col-md-4 mb-3'>
                      <label htmlFor='default_rate'>
                        Minimum rate <span className='text-danger'>*</span>
                      </label>
                      {editing ? (
                        <div>
                          <input
                            type='text'
                            className={`form-control ${
                              errors?.minimum_rate &&
                              touched?.minimum_rate &&
                              "is-invalid"
                            }`}
                            name='minimum_rate'
                            id='minimum_rate'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='0.00'
                            value={values?.minimum_rate}
                          />
                          {errors?.minimum_rate && touched?.minimum_rate && (
                            <span className='text-danger'>
                              {errors?.minimum_rate}
                            </span>
                          )}
                        </div>
                      ) : (
                        <p className='form-control border-0 shadow'>
                          {values.minimum_rate}
                        </p>
                      )}
                    </div>
                    <div className='col-md-4 mb-3'>
                      <label htmlFor='default_rate'>
                        Maximum rate <span className='text-danger'>*</span>
                      </label>
                      {editing ? (
                        <div>
                          <input
                            type='text'
                            className={`form-control ${
                              errors?.maximum_rate &&
                              touched?.maximum_rate &&
                              "is-invalid"
                            }`}
                            name='maximum_rate'
                            id='maximum_rate'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder='0.00'
                            value={values?.maximum_rate}
                          />
                          {errors?.maximum_rate && touched?.maximum_rate && (
                            <span className='text-danger'>
                              {errors?.maximum_rate}
                            </span>
                          )}
                        </div>
                      ) : (
                        <p className='form-control border-0 shadow'>
                          {values.maximum_rate}
                        </p>
                      )}
                    </div>
                    <div className=''>
                      {errors?.minMax &&
                        touched?.maximum_rate &&
                        touched?.minimum_rate && (
                          <p className='alert alert-warning'>
                            {errors?.minMax}
                          </p>
                        )}
                    </div>
                  </div>
                </div>
              )}
              <div className='row mb-3 mt-3'>
                <div className='col-md-3 col-lg-2'></div>
                <div className='col-md-7 col-lg-6'>
                  {!editing && hasEditCover && (
                    <button
                      onClick={() => setEditing(true)}
                      className='btn btn-primary btn-sm px-4 rounded'
                    >
                      <span>Edit</span>
                    </button>
                  )}
                  {editing && (
                    <div className='d-flex gap-2'>
                      <button
                        onClick={() => {
                          setEditing(false);
                          resetFormValues();
                        }}
                        className='btn btn-secondary btn-sm px-4 rounded'
                      >
                        <span>Cancel</span>
                      </button>
                      <button
                        type='submit'
                        className='btn btn-primary btn-sm px-4 rounded'
                      >
                        <span>Submit</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleCover;
